module.exports = __webpack_public_path__ + "static/media/quote-angelou-feel-fr.3ff66cdf.png";